// removed by extract-text-webpack-plugin
module.exports = {"sideMenu":"sideMenu__2mXl-","menu":"menu__rAFZF","menu-item":"menu-item__3Iqim","menu-item-active":"menu-item-active__31Hen","burgerButton":"burgerButton__29ZzO","sideMenu-open":"sideMenu-open__1uLYc"};


//////////////////
// WEBPACK FOOTER
// ./components/sideMenu/style.css
// module id = n6Wo
// module chunks = 14